import { ChevronDownIcon } from "@heroicons/react/24/outline";
import InputBase from "./InputBase";
import { twMerge } from "tailwind-merge";

type SelectInputProps = {
  label: string;
  placeholder: string;
  inputClassName?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  error?: string | null;
  icon?: React.ReactNode | null;
  helperText?: string;
  options: Option[];
  required: boolean;
  disabled?: boolean;
}

type Option = {
  value: string;
  label: string;
}

const SelectInput = ({
  label,
  placeholder,
  inputClassName,
  value,
  onChange,
  error = '',
  icon = null,
  helperText = '',
  options, required,
  disabled = false
}: SelectInputProps) => {
  return (
    <InputBase label={label} required={required} icon={icon} helperText={helperText} error={error}>
      <div className="relative">
        <select
          id={`${label}-select`}
          required={required}
          disabled={disabled}
          onChange={onChange}
          value={value || ''}
          className={twMerge(`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 appearance-none bg-white transition-all ${
            error
              ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
              : 'border-gray-300 focus:ring-brand-500 focus:border-brand-500'
          }`, inputClassName)}
        >
          {!value && <option value="">{placeholder}</option>}
          {options.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
        <ChevronDownIcon className="w-5 h-5 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none" />
      </div>
    </InputBase>
  );
};

export default SelectInput;
